export const tenderReportTemplate = `<html>
  <head>
    <style>
      body {
        font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        border: 1px Solid #d6d6d6;
        margin-top: 20px;
      }

      table caption {
        border: 1px Solid #d6d6d6;
        padding: 8px;
        background: #d6d6d6;
        color:#333;
        font-weight: bold;
      }

      table td, table th {
        border: 1px Solid #d6d6d6;
        padding: 5px 5px;
        text-align: left;
      }

      h2, h4 {
        margin: 10px 0;
      }
    </style>
  </head>
  <body>
    <div class="header" style="width: 100%">
      <h2 style="text-align: center">Burhani Guards Pakistan</h2>
      <h2 style="text-align: center">Eid-Ul-Adha #HIJRIYEAR</h2>
      <h4 style="text-align: center">#TENDERDATE</h4>
    </div>
    <div class="content" style="width: 100%">#ITEMTABLES</div>
  </body>
</html>
`;

export const tenderReportItemTemplate = `<table>
  <caption>
    #ITEMNAME
  </caption>
  <thead>
    <tr>
      <th width="80%">Customer</th>
      <th width="20%">Price</th>
    </tr>
  </thead>
  <tbody>
    #ITEMS
  </tbody>
</table>
`;
